import { apiTaskClassifications } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'tasks/classifications';

const config = [
  { actionType: 'getAll', apiPath: apiTaskClassifications, method: get, actionParams: { limit: 0 } },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiTaskClassifications}/${params.id}`, method: get },
];

export const { getAll, getOne } = createThunks(typePrefix, config);
